export default __webpack_public_path__ + "static/media/RG.3312e337.svg";